import {EDocumentType, EPaymentType} from 'src/containers/User';

import {EFormStep, ELeadClientCreatingError} from '../definitions';

export default {
  errors: {
    [ELeadClientCreatingError.TAX_NUMBER_ALREADY_IN_USE]:
      'A profile with this TIN/INN and contact person already exists.',
    [ELeadClientCreatingError.EMAIL_ALREADY_IN_USE]:
      'Email is already in use. Please use a different email.',
  },
  labels: {
    companyName: 'Company name',
    taxNumber: 'TIN',
    vatNumber: 'VAT number',
    binNumber: 'Business Identification Number (BIN)',
    blrTaxNumber: 'UNP / TIN',
    ogrn: 'OGRN/OGRNIP code',
    countryCode: 'Country',
    currencyCode: 'Currency',
    resellerId: 'Jurisdiction',
    contactName: 'Contact details',
    phone: 'Phone number',
    company: 'Company',
    responsibleManagerId: 'Assigned edna manager',
    channel: 'Channel',
    tariff: 'Rate',
    special: 'Personal',
    documentType: 'Offer/Paper contract',
    tariffConditions: 'Description of pricing conditions',
    paymentType: 'Payment type',
    manager: 'Person responsible for audit',
    isChecked: 'The audit in the financial and legal department has been passed',
    depositAmount: 'Security payment amount',
    overdraftAmount: 'Overdraft amount',
    paymentPeriod: 'License payment period in days',
    cancellationPeriod: 'Number of days until the license is cancelled in case of non-payment',
    disableBilling: 'Disable billing for the client',
    contractNumber: 'Contract number',
    pilotContractNumber: 'Contract number (optionally)',
    contractDate: 'Date of contract',
    pilotContractDate: 'Valid till',
    partnerId: 'Agent',
    hasPartner: 'Lead from agent',
    bank: 'Registration bank',
    isAgreedOverdraft: 'The setup and the amount of overdraft were approved',
    agreedOverdraft: 'Overdraft approved by',
    comment: 'Agent’s comment',
  },
  placeholders: {
    email: 'yourname@company.com',
    phone: 'Enter the phone number',
    currencyCode: 'Select a currency',
    resellerId: 'Select a jurisdiction',
    channel: '-',
    tariff: 'Select a rate',
    partnerId: 'Select agent',
    agreedOverdraft: 'Select the approver',
    managerResponsibleForCheckingId: 'Select person responsible for audit',
  },
  buttons: {
    create: 'Create',
    next: 'Next',
    addTariff: 'Add pricing',
    confirm: 'Confirm',
    agreed: 'Approved',
  },
  titles: {
    dataAndContacts: 'Company details and contacts',
    calculationAndLicenses: 'Mutual settlements and licenses',
    companyTariffs: 'Company rates',
  },
  subtitles: {
    commonData: 'General details',
    contacts: 'Contacts',
    paymentSystem: 'Agreed payment system',
    credits: 'Credit facilities',
    licensesConditions: 'License activation conditions',
    proposedCompanyTariffs: 'Create available tariff plans for the client',
    billing: 'Billing',
    contract: 'Contract',
  },
  steps: {
    [EFormStep.DETAILS]: 'Company details',
    [EFormStep.CALCULATION_AND_LICENSES]: 'Mutual settlements and licenses',
    [EFormStep.TARIFFS]: 'Client pricing',
  },
  documentTypes: {
    [EDocumentType.AGREEMENT]: {
      label: 'Offer',
      message:
        'Attention! This type of registration is available for clients with no paper contracts signed. To work with the service, the client will have to accept the user agreement. Confirm your selection',
    },
    [EDocumentType.CONTRACT]: {
      label: 'Paper contract',
      message:
        'Attention! This type of registration is only available for a client with whom you have already signed a contract. Confirm your selection',
    },
    [EDocumentType.TECH_PARTNER_CONTRACT]: {
      label: 'Tech partner (contract)',
      message:
        'Attention! This type of registration is only available for a client with whom you have already signed a contract. Confirm your selection',
    },
    [EDocumentType.TECH_PARTNER_OFFER]: {
      label: 'Tech partner (agreement)',
      message:
        'Attention! This type of registration is available for clients with no paper contracts signed. To work with the service, the client will have to accept the user agreement. Confirm your selection',
    },
    [EDocumentType.PILOT]: {
      label: 'Pilot',
    },
  },
  hasNoLeadContractPermission:
    'Attention! Only Tariff Department employees can create clients who work under a paper contract in the system. A lead will be created once a scan of the signed contract has been uploaded to the CRM system and a request has been sent by email to <0>{{email}}</0>',
  paymentTypes: {
    [EPaymentType.POSTPAID]: {
      label: 'Post-payment',
    },
    [EPaymentType.PREPAYMENT]: {
      label: 'Prepayment',
    },
    [EPaymentType.MIXED_PREPAYMENT]: {
      label: 'Mixed payment',
    },
  },
  error: {
    confirm: 'Confirmation required',
  },
  billingMessage:
    'Important! You can only disable billing for clients with whom old-type contacts were concluded. To disable billing, you must approve it with your manager. Confirm your selection',
  blrBillingMessage:
    "Billing isn't available in your jurisdiction. All client payments are handled by Infosintez Ltd.",
};
